export const RGB_COLOR_REGEX = /\((\d+),\s*(\d+),\s*(\d+)(,\s*(\d*.\d*))?\)/
export const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
export default class Color {
  public r: number = 255
  public g: number = 255
  public b: number = 255
  public a: number = 255

  constructor()
  constructor(colorStr?: string)
  constructor(r?: string | number, g?: number, b?: number)
  constructor(r?: string | number, g?: number, b?: number, a?: number) {
    if (typeof r === "string") {
      r = r.trim()
      if (r.indexOf("#") === 0) {
        r = r.replace(shorthandRegex, function(m, r1, g1, b1) {
          return r1 + r1 + g1 + g1 + b1 + b1
        })
        r = r.substr(r.indexOf("#") + 1)
        this.r = parseInt(r.substr(0, 2), 16)
        this.g = parseInt(r.substr(2, 2), 16)
        this.b = parseInt(r.substr(4, 2), 16)
      } else if (r.indexOf("rgb") === 0) {
        const res = RGB_COLOR_REGEX.exec(r)
        if (!res) return
        this.r = parseInt(res[1], 10)
        this.g = parseInt(res[2], 10)
        this.b = parseInt(res[3], 10)
        this.a = res[5] ? parseFloat(res[5]) : 1
      }
    } else {
      this.r = r || 0
      this.g = g || 0
      this.b = b || 0
      this.a = a || 1
    }
  }
  toHex() {
    return "#" + this.r.toString(16) + this.g.toString(16) + this.b.toString(16)
  }

  toRgb() {
    return `rgb(${this.r}, ${this.g}, ${this.b})`
  }

  toRgba() {
    return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`
  }
  islight() {
    return (this.r + this.g + this.b) / 3 > 152
  }
}
